import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import ReactPixel from 'react-facebook-pixel';
ReactPixel.init('934018902712307');
ReactPixel.pageView();
render(<App data-id="element-128" />, document.getElementById('root'));